import { NgModule } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputGroupComponent, NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTransferModule } from 'ng-zorro-antd/transfer';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzBackTopModule } from 'ng-zorro-antd/back-top';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';
import { NzTreeViewModule } from 'ng-zorro-antd/tree-view';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [],
  imports: [
    NzButtonModule,
    NzInputModule,
    NzInputNumberModule,
    NzSelectModule,
    NzTimePickerModule,
    NzUploadModule,
    NzEmptyModule,
    NzTabsModule,
    NzMessageModule,
    NzModalModule,
    NzNotificationModule,
    NzMenuModule,
    NzCheckboxModule,
    NzBreadCrumbModule,
    NzDropDownModule,
    NzIconModule,
    NzLayoutModule,
    NzDatePickerModule,
    NzRadioModule,
    NzAvatarModule,
    NzPageHeaderModule,
    NzToolTipModule,
    NzDividerModule,
    NzCollapseModule,
    NzResultModule,
    NzDescriptionsModule,
    NzTagModule,
    NzBadgeModule,
    NzTableModule,
    NzPopconfirmModule,
    NzTransferModule,
    NzPopoverModule,
    NzPaginationModule,
    NzSwitchModule,
    NzAlertModule,
    NzListModule,
    NzSpinModule,
    NzSliderModule,
    NzStepsModule,
    NzCardModule,
    NzBackTopModule,
    NzProgressModule,
    NzTreeModule,
    NzCascaderModule,
    NzTreeViewModule,
    NzGridModule,
    DragDropModule
  ],
  exports: [
    NzButtonModule,
    NzInputModule,
    NzInputNumberModule,
    NzSelectModule,
    NzTimePickerModule,
    NzUploadModule,
    NzEmptyModule,
    NzTabsModule,
    NzMessageModule,
    NzModalModule,
    NzNotificationModule,
    NzSpinModule,
    NzMenuModule,
    NzCheckboxModule,
    NzBreadCrumbModule,
    NzDropDownModule,
    NzIconModule,
    NzLayoutModule,
    NzDatePickerModule,
    NzRadioModule,
    NzAvatarModule,
    NzPageHeaderModule,
    NzToolTipModule,
    NzDividerModule,
    NzCollapseModule,
    NzResultModule,
    NzDescriptionsModule,
    NzTagModule,
    NzBadgeModule,
    NzTableModule,
    NzPopconfirmModule,
    NzTransferModule,
    NzPopoverModule,
    NzPaginationModule,
    NzSwitchModule,
    NzAlertModule,
    NzListModule,
    NzSliderModule,
    NzStepsModule,
    NzCardModule,
    NzBackTopModule,
    NzProgressModule,
    NzTreeModule,
    NzCascaderModule,
    NzTreeViewModule,
    NzGridModule,
    DragDropModule
  ]
})
export class NgZorroModule { }
